var _path;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgPreview = function SvgPreview(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 13,
    viewBox: "0 0 19 13",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.5083 12.1429C4.0874 12.1429 0.498535 7.73376 0.498535 6.40076C0.498535 5.06775 4.09424 0.665405 9.5083 0.665405C15.0112 0.665405 18.5181 5.06775 18.5181 6.40076C18.5181 7.73376 15.0112 12.1429 9.5083 12.1429ZM9.5083 10.3177C13.3091 10.3177 16.1733 7.27576 16.1733 6.40076C16.1733 5.68298 13.3091 2.48376 9.5083 2.48376C5.70068 2.48376 2.8501 5.68298 2.8501 6.40076C2.8501 7.27576 5.70068 10.3177 9.5083 10.3177ZM9.51514 9.52478C7.77197 9.52478 6.38428 8.09607 6.38428 6.40076C6.37744 4.65759 7.77197 3.28357 9.51514 3.28357C11.2515 3.28357 12.6392 4.66443 12.6392 6.40076C12.6392 8.09607 11.2515 9.52478 9.51514 9.52478ZM9.50146 7.33044C10.021 7.33044 10.438 6.90662 10.438 6.40076C10.438 5.88806 10.021 5.47107 9.50146 5.47107C8.99561 5.47107 8.57861 5.88806 8.57861 6.40076C8.57861 6.90662 8.99561 7.33044 9.50146 7.33044Z",
    fill: "currentColor"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgPreview, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/preview.30fe79a9.svg";
export { ForwardRef as ReactComponent };